export default "__VITE_ASSET__CUNWDCw5__"